module.exports = __webpack_public_path__ + "static/media/icons-ic-edit-contact-accepted.138e0464.svg";